export const getEventTypeColor = (eventType: string): string => {
  if (eventType.startsWith('grn_')) return 'blue';
  if (eventType.startsWith('spid_')) return 'green';
  if (eventType.startsWith('order_')) return 'orange';
  if (eventType.startsWith('invoice_') || eventType.startsWith('soa_'))
    return 'red';
  return 'default';
};

export const formatEventTypeLabel = (eventType: string): string =>
  eventType.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
